// import "./Header.scss"; // Removed for version update
import Link from 'next/link';
import Notification from './Notification';
import { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useCurrentContext } from '../../Context/CurrentPageContext';
import store from '../../../store';
import { Logout } from '../../../store/actions/login';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { useCountdown } from '../../utils/countDownTimer';
const Header = ({ userData }) => {
  const dispatch = useDispatch();
  const [mode, setmode] = useState(false);
  const [current, setCurrent] = useCurrentContext();
  const [profileBox, setprofileBox] = useState(false);
  const [currentMode, setCurrentMode] = useState(localStorage.getItem('mode') ? localStorage.getItem('mode') : 'test');
  const userRole = useSelector((state) => state.user.roleName);

  const router = useRouter();
  const logout = (e) => {
    store.dispatch(Logout(router));
  };
  // store.subscribe(() => setKyc(store.getState().merchant.merchant.is_active));



  useEffect(() => {
    localStorage.setItem('mode', currentMode);
    store.dispatch({
      type: currentMode === 'test' ? 'TEST_MODE' : 'LIVE_MODE',
    });
  }, [currentMode]);

  const wrapperRef = useRef(null);
  const wrapperRef2 = useRef(null);
  useOutsideAlerter(wrapperRef);
  useOutsideAlerter(wrapperRef2);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setprofileBox(false);
          setmode(false);
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }
  return (
    <div className='header'>
      <div className='container-fluid padding-15'>
        <div className='heade-inner'>
          <div className='header-left'>
            {userRole === 'External CRM' ? (
              <img className='' src='/images/logo-business-suit.svg' />
            ) : (
              <Link href='/'>
                <a>
                  <img className='' src='/images/logo-business-suit.svg' />
                </a>
              </Link>
            )}
          </div>
          <div className='header-right'>
            <div className='notification display-center margin-r20'>
              <Notification />
            </div>
            <div className='pos-rel'>
              <div onClick={() => setprofileBox(!profileBox)} className='header-btn down-arrow'>
                {userData ? userData.name : ''}
              </div>
              {profileBox ? (
                <div className='profile-box' ref={wrapperRef}>
                  {/* <a
                    href="/merchant-view"
                    className="profile-info d-flex justify-content-between cursor-pointer"
                  >
                    <span className="fs16 lh-22 metro-m text-d-blue">
                      My Account
                    </span>
                    <span className="lh-18">
                      <img src="/images/black-right-arrow.svg" />
                    </span>
                  </a> */}
                  <button onClick={logout} className='blue-btn '>
                    Logout
                  </button>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position='top-center' autoClose={1500} />
    </div>
  );
};

export default Header;
const getReturnValues = (countDown) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return { minutes, seconds };
};
